<!--
  @Author: ljl
  @Desc: 阶梯费率tale
  @Date: 2024-09-06
-->

<template>
  <div class="rate_table">
    <div
      class="rate_range_item"
      :style="rateRangeStyle"
    >
      <span class="span_item" :style="spanItemStyle"
        >本月下发总额：{{
          issueData.customerCurrentMonthDistributeAmount ? issueData.customerCurrentMonthDistributeAmount : '0.00'
        }}元</span
      >
      <span
        class="span_item"
        :style="spanItemStyle"
        v-if="isShow"
        >上月下发总额：{{ issueData.customerLastMonthDistributeAmount ? issueData.customerLastMonthDistributeAmount : '0.00' }}元</span
      >
      <div class="rate_range_title">
        <div class="party"></div>
        <span>当前所在下发区间：</span>
        <span class="green_text"
          v-if="data.filter(it => !!it.isCurrent)[0]"
          >费率{{ data.filter(it => !!it.isCurrent)[0].distributeRate }}</span
        >
      </div>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="cellStyle"
      :cell-style="cellStyle"
    >
      <el-table-column
        v-for="(it, index) in tableTitleList"
        :key="index"
        :prop="it"
        :label="it"
        :width="(index == 0 || index == 1) ? '8%' : Math.floor(84 / tableTitleList.length - 2) + '%'" 
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    issueData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    marginBottom: {
      type: String,
      default: "16px"
    },
    isSmallScreen: {
      type: Boolean,
      default: false
    },
    isShow: { // 代理首页不显示上月下发总额
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableData: [],
      tableTitleList: [],
      rateRangeStyle: {
        'margin-bottom': this.marginBottom
      },
      spanItemStyle: {
        'margin': '0'
      }
    };
  },
  watch: {
    data: {
      handler(newValue, oldValue) {
        // 表头
        this.tableTitleList = newValue.map(it => it.rateRange);
        // 数据
        const valueList = newValue.map(it => it.distributeRate);
        this.tableTitleList.unshift("下发阶梯");
        valueList.unshift("下发费率");
        const mergeObj = {};
        const mergeList = [];
        for (let i = 0; i < this.tableTitleList.length; i++) {
          mergeObj[this.tableTitleList[i]] = valueList[i];
        }
        mergeList.push(mergeObj);
        this.tableData = mergeList;
      },
      deep: true,
      immediate: true
    },
    isSmallScreen: {
      handler(newValue, oldValue) {
        console.log(newValue,'newValue')
        if(!newValue) {
          this.rateRangeStyle['justify-content'] = 'start'
          this.spanItemStyle['margin'] = '0 70px 0 0'
        }else {
          this.rateRangeStyle['justify-content'] = 'space-between'
          this.spanItemStyle['margin'] = '0'
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 填充颜色
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (
        !!this.data.filter(it => !!it.isCurrent)[0] &&
        column.property == this.data.filter(it => !!it.isCurrent)[0].rateRange
      ) {
        return { background: "rgba(42,220,129,0.25)" };
      }
    }
  }
};
</script>

<style>
.rate_table .el-table td.el-table__cell:nth-child(1) {
  background: #fafafa;
}
.rate_table .el-table td.el-table__cell:nth-child(1) div {
  color: #272727;
  font-weight: 500;
}
.rate_table .el-table .cell {
  padding-right: 0 !important;
}
.rate_table .el-table th.el-table__cell>.cell {
  padding-right: 0 !important;
}
</style>

<style lang="scss" scoped>
.rate_table {
  width: 100%;
  background: #fff;
  padding: 20px 24px 24px;
}
.rate_range_item {
  display: flex;
  .span_item {
    font-family: PingFangSC, PingFang SC;
    font-size: 14px;
    color: #8c8c8c;
    &:nth-child(1) {
      color: #272727;
    }
    &:nth-child(2) {
      display: block;
    }
  }
  .rate_range_title {
    display: flex;
    align-items: center;
    .party {
      width: 16px;
      height: 10px;
      background: #13bf85;
    }
    span {
      color: #8c8c8c;
      font-size: 14px;
      margin-left: 6px;
    }
    .green_text {
      font-weight: 500;
      color: #13bf85;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rateRange.vue